const defaultLang = 'en';

function getLang() {    
    return window.lang || defaultLang;
}

export default {
    created() {
        this.i18n = this.getStrings();
    },
    data: function() {
        return {
            i18n: {},
            lang: getLang(),
        };
    },
    getLang: getLang,
    methods: {    
        getDefaultStrings() {
            const i18n = this.$options.i18n || window.i18n;
            if (!i18n) {
                return {};
            }
            return i18n[defaultLang] || {};
        },
        getStrings() {
            const i18n = this.$options.i18n || window.i18n;
            if (!i18n) {
                return {};
            }
            return i18n[getLang()] || i18n[defaultLang] || {};
        },
        $t(key) {
            const strings = this.getStrings();
            let val = strings[key];
            if (!val) {
                const defaults = this.getDefaultStrings();
                val = defaults[key];
                if (!val) val = key;
            }
            return val;
        },
        declension(x,t1,t2,t05) {
            let r = x%10; 
            if (r == 1) return t1;
            if (r >1 && r <=4) return t2;
            return t05;
        },
        setMeta(name, content) {
            let meta = document.querySelector(`meta[property='${name}']`);
            if (!meta) {
                meta = document.createElement("meta");
                meta.name = name;
                meta.property = name;
                document.head.appendChild(meta);
            }
            meta.content = content;
        },
    }
}